module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jBZ8z"))).then(() => parcelRequire('cfehG'));